module.exports = "/images/circle.png?bb6fb0a8eeb56f6bef9fe2b6b9fe0405";